export default `
  subscription OnDeleteCardType($workflowId: String) {
    onDeleteCardType(workflowId: $workflowId) {
      id
    }
  }
`
